export default "__VITE_ASSET__CNo8ax0e__"